export default __webpack_public_path__ + "static/media/cam_down_ex.2cddc89b.svg";